import React from "react";
import {
    DefaultMealImageRiceMeal, TicketChip
} from "../../../../../components/buttons/IconButtons";
import CustomTooltip from "../../../../../components/CustomTooltip";
import {useTranslation} from "react-i18next";
import CustomCard from "../../../../../components/CustomCard";
import CustomUserChip from "../../../../../components/CustomUserChip";
import {POSITION_MODEL} from "../../../../../Helpers/PositionModel";
import {getUnitTransByName} from "../../Ingredients/Model/Models";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 */

const MealForecastCard = ({item}) => {
    const { t } = useTranslation();

    return (
        <CustomCard classCard={`border-radius-4px card-shades-100-50`} classes={"h-100 w-100 d-flex flex-column"}>
            <div className={"d-flex justify-content-between align-items-center"}>
                <div className={"d-flex justify-content-start align-items-center flex-grow-1 minw-0"}>
                    <CustomCard classCard={`border-radius-4px background-shades-100 border-0`} classContent={"p-0"}>
                        {item?.meal?.image ?
                            <img className={"w-46px h-48px border-radius-4px"} src={`data:image/png;base64,${item?.meal?.image}`} alt='add' />
                            :
                            <DefaultMealImageRiceMeal width={46} height={48}/>
                        }
                    </CustomCard>

                    <div className={"flex-grow-1 minw-0 mr-5"}>
                        <CustomTooltip
                            text={item?.meal?.foodieItemName}
                            classes={"ibl-h3 font-color-general-950 ibl-font-w-600 text-ellipsis-2-rows ml-2"}
                            showIfTruncated={true}
                            placement={"top"}
                        />
                    </div>
                </div>
                <div className={"text-right"}>
                    <p className={"fs-12px mb-1"}>{t("total_orders")}</p>
                    <CustomUserChip
                        className="mt-0 chip-secondary-150-50 mr-0"
                        name={ <CustomTooltip
                            text={ item?.meal?.total }
                            classes={`fs-14px text-ellipsis-1-row`}
                            showIfTruncated={true}
                        />}
                        Icon={TicketChip}
                        showAvatar={true}
                        variant="compact"
                        iconPosition={POSITION_MODEL.LEFT}
                        classNameIcon={"icon-color-secondary-600"}
                    />
                </div>
            </div>

            <div className={"row border-top-shades-300 mt-3"}>
                <p className={`fs-14px ibl-font-w-600 text-capitalize my-3 p-0`}>{t("ingredients_breakdown")}</p>
            </div>
            <div className={"d-flex flex-wrap gap-2"}>
                { item.ingredients.map(e =>
                    <CustomCard classCard={`card-border-8px background-shades-100 border-0`} classContent={"p-2"}>
                        <p className={`fs-14px`}>{e.ingredientName} <span className={"ibl-font-w-600"}>{e.quantity + " " + t(getUnitTransByName(e.unit))}(s)</span></p>
                    </CustomCard>
                )}
            </div>
        </CustomCard>

    );
};

export default MealForecastCard;
